import { render, staticRenderFns } from "./Csr.vue?vue&type=template&id=53a03878&scoped=true"
import script from "./Csr.vue?vue&type=script&lang=js"
export * from "./Csr.vue?vue&type=script&lang=js"
import style0 from "./Csr.vue?vue&type=style&index=0&id=53a03878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a03878",
  null
  
)

export default component.exports